import { render, staticRenderFns } from "./CallStudioEditor.vue?vue&type=template&id=4cbbfa00&scoped=true"
import script from "./CallStudioEditor.vue?vue&type=script&lang=js"
export * from "./CallStudioEditor.vue?vue&type=script&lang=js"
import style0 from "./CallStudioEditor.vue?vue&type=style&index=0&id=4cbbfa00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbbfa00",
  null
  
)

export default component.exports